/* DeviceTypeComponent.js */

"use strict";

const EventEmitter = require("events");
const _ = require("lodash");
const Renderer = require("./DeviceTypeRenderer");

class DeviceTypeComponent extends EventEmitter {
    constructor(value) {
        super();
        this._entity = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._entity = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue() {
        this.emit("Update", this._entity);
    }

    getIconData() {
        let typeBaseGroupMap = _.get(this._entity, "typeBaseGroupMap");
        let detectedTypeBase = _.get(this._entity, "detectedTypeBase");
        // single edge case where icon name and it's title do not match
        if (typeBaseGroupMap[detectedTypeBase] === undefined) {
            return {icon: "common.default_device", title: "Unknown"};
        }
        return {
            icon: "common." + _.snakeCase(typeBaseGroupMap[detectedTypeBase]),
            title: detectedTypeBase,
        };
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DeviceTypeComponent;
